// German

export default {

  component: {
    jobAdList: {
      title: 'Stellenangebote',
      jobs: 'Stellen',
      noJobAds: 'Es sind momentan keine Stellen ausgeschrieben.',
    },

    jobAdCard: {
      openUntil: date => `Offen bis ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Vielen Dank.',
      readyInfo: 'Ihre Bewerbung ist nun eingegangen und der Personalvermittler wird sich in Kürze mit Ihnen in Verbindung setzen.',
      luck: 'Viel Glück!',
    },

    jobAdSeeYou: {
      title: 'Vielen Dank.',
      description: 'Deine Bewerbung ist gespeichert, und wir haben Dir einen Link gesendet, um deine Bewerbung später fortzusetzen.',
    },

    unpublished: {
      title: 'Unveröffentlicht',
      info: 'Die Stellenanzeige wurde noch nicht veröffentlicht.',
    },
  },

  page: {},

}
